/**
 * Homepage: scale first two collection-with-sidebar sections to fit ~maxCombinedPx total height.
 * Preserves layout proportions (uniform scale); compensates layout flow with negative margins.
 */
(function () {
  const MAX_COMBINED_PX = 500;
  const SECTION_IDS = [
    'shopify-section-product_list_with_sidebar_2_McgpQC',
    'shopify-section-collection_with_sidebar_dLYgVr',
  ];

  let debounceId;

  function getSections() {
    return SECTION_IDS.map((id) => document.getElementById(id)).filter(Boolean);
  }

  function clearScale(els) {
    els.forEach((el) => {
      el.style.removeProperty('transform');
      el.style.removeProperty('transform-origin');
      el.style.removeProperty('margin-bottom');
    });
  }

  function apply() {
    const els = getSections();
    if (els.length !== 2) return;

    clearScale(els);
    void els[0].offsetHeight;

    const heights = els.map((el) => el.offsetHeight);
    const total = heights.reduce((a, h) => a + h, 0);
    if (total <= 0) return;

    if (total <= MAX_COMBINED_PX) {
      clearScale(els);
      return;
    }

    const scale = MAX_COMBINED_PX / total;
    els.forEach((el, i) => {
      const h = heights[i];
      el.style.transformOrigin = 'top center';
      el.style.transform = `scale(${scale})`;
      el.style.marginBottom = `${-h * (1 - scale)}px`;
    });
  }

  function debouncedApply() {
    clearTimeout(debounceId);
    debounceId = window.setTimeout(() => {
      requestAnimationFrame(apply);
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', debouncedApply);
  } else {
    debouncedApply();
  }

  window.addEventListener('load', () => {
    debouncedApply();
    window.setTimeout(debouncedApply, 400);
    window.setTimeout(debouncedApply, 1200);
  });

  window.addEventListener('resize', debouncedApply);

  document.addEventListener('shopify:section:load', debouncedApply);
  document.addEventListener('shopify:section:reorder', debouncedApply);
})();
